import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";

import "./styles/Banner.css";

const SiteBanner = () => {
  return (
    <Container className="banner">
      <Row>
        <Col className="banner-pipes-name d-flex align-items-center" md={9} sm={8} xs={8}>
          <a href="/">
            <Image
              className="rounded"
              src="/images/PIPES-Logo-FullColor.png"
              alt="PIPES"
              style={{ width: "18%" }}
              fluid
            />
          </a>
        </Col>
        <Col className="banner-container" md={3} sm={4} xs={4}>
          <Image
            className="banner-image"
            src="/images/nlr-logo-horizontal.svg"
            alt="NLR"
            fluid
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SiteBanner;
